import { Box, ColorOptions, Text } from '@jfs/ui-new'
import React from 'react'
import { FlatList } from 'react-native'

const renderItem = ({ item }: any) => {
  return (
    <Box flexDirection={'row'} justify={'space-evenly'} ph={32}>
      <Box f={1} minWidth={150} maxWidth={200}>
        <Text
          title={item.key}
          color={'#0000008A' as ColorOptions}
          fontSize={12}
          fontFamily={'jiotype-medium'}
          lineHeight={20}
          numberOfLines={1}
        />
      </Box>
      <Box f={1} minWidth={150} maxWidth={200}>
        <Text
          title={item.value}
          color={'BLACK_21'}
          fontSize={12}
          fontFamily={'jiotype-medium'}
          lineHeight={20}
          numberOfLines={1}
        />
      </Box>
    </Box>
  )
}
export const List = (data: any) => {
  return (
    <Box borderTopWidth={1} bg={'LIGHT_GREY_SEPARATOR'} p={32} borderTopColor={'#CCCCCC' as ColorOptions}>
      <FlatList data={data?.data} renderItem={renderItem} />
    </Box>
  )
}
